import React from 'react';
import { VehicleDescriptionForm } from 'components/VehicleDescriptionForm/VehicleDescriptionForm';
import './Deposit.scss';
import { usePageTracking } from 'hooks';
import { TRACKING_PAGES } from 'api';
import { useApp } from 'providers';
import { DepositPageContainer } from './DepositPageContainer';

export const VehicleDescriptionPage: React.FC = () => {
  const { user } = useApp();

  usePageTracking(user!.isPro ? TRACKING_PAGES.EQUIPEMENT_PRO : TRACKING_PAGES.EQUIPEMENT_PART);

  return (
    <DepositPageContainer isPro={user!.isPro} big>
      <VehicleDescriptionForm />
    </DepositPageContainer>
  );
};
